import {
  POWERBI_SECURITY_DATA,
  POWERBI_SECURITY_GET_DATA,
  POWERBI_SECURITY_ADD_DATA,
  POWERBI_SECURITY_UPDATE_DATA,
  POWERBI_SECURITY_DELETE_DATA,
  POWERBI_ROLES_DATA,
  POWERBI_SECURITY_UPDATE_SEQUENCE,
  POWERBI_SECURITY_SYNC_PAGES,
  POWERBI_SECURITY_GET_REPORT_PAGES,
} from "./Constants";

// ==================== Actions for Security List ====================

// Load all Power BI security configurations
const loadPowerBISecurityDataRequest = () => ({
  type: POWERBI_SECURITY_DATA.POWERBI_SECURITY_DATA_LOAD,
});

const setPowerBISecurityDataSuccess = (securityList) => ({
  type: POWERBI_SECURITY_DATA.POWERBI_SECURITY_DATA_SUCCESS,
  securityList,
});

const setPowerBISecurityDataFail = (error) => ({
  type: POWERBI_SECURITY_DATA.POWERBI_SECURITY_DATA_FAIL,
  error,
});

// ==================== Actions for Single Security Detail ====================

// Get specific security by ID
const loadPowerBISecurityGetDataRequest = (id) => ({
  type: POWERBI_SECURITY_GET_DATA.POWERBI_SECURITY_GET_DATA_LOAD,
  id,
});

const setPowerBISecurityGetDataSuccess = (security) => ({
  type: POWERBI_SECURITY_GET_DATA.POWERBI_SECURITY_GET_DATA_SUCCESS,
  security,
});

const setPowerBISecurityGetDataFail = (error) => ({
  type: POWERBI_SECURITY_GET_DATA.POWERBI_SECURITY_GET_DATA_FAIL,
  error,
});

// ==================== Actions for Add Security ====================

// Add new Power BI security configuration
const loadPowerBISecurityAddDataRequest = (data) => ({
  type: POWERBI_SECURITY_ADD_DATA.POWERBI_SECURITY_ADD_DATA_LOAD,
  data,
});

const setPowerBISecurityAddDataSuccess = (security) => ({
  type: POWERBI_SECURITY_ADD_DATA.POWERBI_SECURITY_ADD_DATA_SUCCESS,
  security,
});

const setPowerBISecurityAddDataFail = (error) => ({
  type: POWERBI_SECURITY_ADD_DATA.POWERBI_SECURITY_ADD_DATA_FAIL,
  error,
});

// ==================== Actions for Update Security ====================

// Update existing Power BI security configuration
const loadPowerBISecurityUpdateDataRequest = (id, data) => ({
  type: POWERBI_SECURITY_UPDATE_DATA.POWERBI_SECURITY_UPDATE_DATA_LOAD,
  id,
  data,
});

const setPowerBISecurityUpdateDataSuccess = (security) => ({
  type: POWERBI_SECURITY_UPDATE_DATA.POWERBI_SECURITY_UPDATE_DATA_SUCCESS,
  security,
});

const setPowerBISecurityUpdateDataFail = (error) => ({
  type: POWERBI_SECURITY_UPDATE_DATA.POWERBI_SECURITY_UPDATE_DATA_FAIL,
  error,
});

// ==================== Actions for Delete Security ====================

// Delete Power BI security configuration
const loadPowerBISecurityDeleteDataRequest = (id) => ({
  type: POWERBI_SECURITY_DELETE_DATA.POWERBI_SECURITY_DELETE_DATA_LOAD,
  id,
});

const setPowerBISecurityDeleteDataSuccess = () => ({
  type: POWERBI_SECURITY_DELETE_DATA.POWERBI_SECURITY_DELETE_DATA_SUCCESS,
});

const setPowerBISecurityDeleteDataFail = (error) => ({
  type: POWERBI_SECURITY_DELETE_DATA.POWERBI_SECURITY_DELETE_DATA_FAIL,
  error,
});

// ==================== Actions for PowerBI Roles List ====================

// Load all PowerBI roles
const loadPowerBIRolesDataRequest = () => ({
  type: POWERBI_ROLES_DATA.POWERBI_ROLES_DATA_LOAD,
});

const setPowerBIRolesDataSuccess = (roles) => ({
  type: POWERBI_ROLES_DATA.POWERBI_ROLES_DATA_SUCCESS,
  roles,
});

const setPowerBIRolesDataFail = (error) => ({
  type: POWERBI_ROLES_DATA.POWERBI_ROLES_DATA_FAIL,
  error,
});

// ==================== Actions for Update Sequence ====================

// Update sequence order for Power BI security configurations
const loadPowerBISecurityUpdateSequenceRequest = (updates) => ({
  type: POWERBI_SECURITY_UPDATE_SEQUENCE.POWERBI_SECURITY_UPDATE_SEQUENCE_LOAD,
  updates,
});

const setPowerBISecurityUpdateSequenceSuccess = () => ({
  type: POWERBI_SECURITY_UPDATE_SEQUENCE.POWERBI_SECURITY_UPDATE_SEQUENCE_SUCCESS,
});

const setPowerBISecurityUpdateSequenceFail = (error) => ({
  type: POWERBI_SECURITY_UPDATE_SEQUENCE.POWERBI_SECURITY_UPDATE_SEQUENCE_FAIL,
  error,
});

// ==================== Actions for Sync Pages ====================

// Sync pages for a report
const loadPowerBISecuritySyncPagesRequest = (reportId, registryId, pages) => ({
  type: POWERBI_SECURITY_SYNC_PAGES.POWERBI_SECURITY_SYNC_PAGES_LOAD,
  reportId,
  registryId,
  pages,
});

const setPowerBISecuritySyncPagesSuccess = () => ({
  type: POWERBI_SECURITY_SYNC_PAGES.POWERBI_SECURITY_SYNC_PAGES_SUCCESS,
});

const setPowerBISecuritySyncPagesFail = (error) => ({
  type: POWERBI_SECURITY_SYNC_PAGES.POWERBI_SECURITY_SYNC_PAGES_FAIL,
  error,
});

// ==================== Actions for Get Report Pages ====================

// Get pages for a specific report by report ID
const loadPowerBISecurityGetReportPagesRequest = (reportId) => ({
  type: POWERBI_SECURITY_GET_REPORT_PAGES.POWERBI_SECURITY_GET_REPORT_PAGES_LOAD,
  reportId,
});

const setPowerBISecurityGetReportPagesSuccess = (pages) => ({
  type: POWERBI_SECURITY_GET_REPORT_PAGES.POWERBI_SECURITY_GET_REPORT_PAGES_SUCCESS,
  pages,
});

const setPowerBISecurityGetReportPagesFail = (error) => ({
  type: POWERBI_SECURITY_GET_REPORT_PAGES.POWERBI_SECURITY_GET_REPORT_PAGES_FAIL,
  error,
});

// ==================== Exports ====================

export {
  loadPowerBISecurityDataRequest,
  setPowerBISecurityDataSuccess,
  setPowerBISecurityDataFail,
  loadPowerBISecurityGetDataRequest,
  setPowerBISecurityGetDataSuccess,
  setPowerBISecurityGetDataFail,
  loadPowerBISecurityAddDataRequest,
  setPowerBISecurityAddDataSuccess,
  setPowerBISecurityAddDataFail,
  loadPowerBISecurityUpdateDataRequest,
  setPowerBISecurityUpdateDataSuccess,
  setPowerBISecurityUpdateDataFail,
  loadPowerBISecurityDeleteDataRequest,
  setPowerBISecurityDeleteDataSuccess,
  setPowerBISecurityDeleteDataFail,
  loadPowerBIRolesDataRequest,
  setPowerBIRolesDataSuccess,
  setPowerBIRolesDataFail,
  loadPowerBISecurityUpdateSequenceRequest,
  setPowerBISecurityUpdateSequenceSuccess,
  setPowerBISecurityUpdateSequenceFail,
  loadPowerBISecuritySyncPagesRequest,
  setPowerBISecuritySyncPagesSuccess,
  setPowerBISecuritySyncPagesFail,
  loadPowerBISecurityGetReportPagesRequest,
  setPowerBISecurityGetReportPagesSuccess,
  setPowerBISecurityGetReportPagesFail,
};
